<app-start-payout-age-form-field
  [tip]="'simulationAge.age.tip' | fms"
  (selectionChange)="onPayoutAgeChange()"
></app-start-payout-age-form-field>
